const customStyles = {
  control: base => ({
    ...base,
    alignItems: 'flex-end',
    backgroundColor: '#f0f3f7',
    borderColor: 'transparent !important',
    boxShadow: 'none',
    cursor: 'pointer',
    minHeight: 57,
    padding: '8px 8px',
    transition: 'all .4s',
    '&:hover': {
      backgroundColor: '#b3f0f0',
    },
  }),
  dropdownIndicator: base => ({
    ...base,
    color: '#6b7480',
    padding: '0 2px',
    '&:hover': {
      color: '#6b7480',
    },
  }),
  indicatorsContainer: base => ({
    ...base,
    alignSelf: 'flex-end',
    height: '16px',
    padding: '16px 0',
  }),
  option: (base, {
    isFocused,
    isSelected
  }) => ({
    ...base,
    backgroundColor: null,
    color: '#353a40',
    cursor: 'pointer',
    fontSize: '0.875rem',
    transition: 'all .4s',
    ':hover': {
      backgroundColor: '#f0f3f7',
    },
    ':active': {
      ...base[':active'],
      backgroundColor: '#b3f0f0',
    },
  }),
  singleValue: base => ({
    ...base,
    color: '#353a40',
    fontSize: '0.875rem',
    margin: '2px 0',
  }),
}

export default customStyles
